import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Search,
  Package,
  User,
  Calendar,
  CheckCircle,
  Clock,
  ArrowRight,
  Truck,
  Bell,
  Download,
  CheckSquare
} from 'lucide-react';
import { API_URL } from '../../Config';
export default function ReadyDemandes() {
  const navigate = useNavigate();
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDemandes, setSelectedDemandes] = useState([]);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    loadDemandes();
  }, []);

  const loadDemandes = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/magasin/ready-demandes`, {
        headers
      });
      
      if (res.data.success) {
        setDemandes(res.data.data.data);
      }
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  const filteredDemandes = demandes.filter(demande => {
    return (
      (demande.numero || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (demande.demandeur?.nom || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const toggleSelectDemande = (demandeId) => {
    setSelectedDemandes(prev =>
      prev.includes(demandeId)
        ? prev.filter(id => id !== demandeId)
        : [...prev, demandeId]
    );
  };

  const selectAll = () => {
    if (selectedDemandes.length === filteredDemandes.length) {
      setSelectedDemandes([]);
    } else {
      setSelectedDemandes(filteredDemandes.map(d => d.id));
    }
  };

  const handleMarkAsRecovered = async () => {
    if (selectedDemandes.length === 0) return;
    
    if (window.confirm(`Marquer ${selectedDemandes.length} demande(s) comme récupérée(s) ?`)) {
      try {
        // Ici vous feriez l'appel API pour marquer comme récupéré
        alert(`Fonctionnalité à implémenter : Marquer ${selectedDemandes.length} demande(s) comme récupérée(s)`);
        setSelectedDemandes([]);
        loadDemandes();
      } catch (err) {
        console.error('Erreur:', err);
      }
    }
  };

  const handleNotify = () => {
    if (selectedDemandes.length === 0) return;
    
    const selected = demandes.filter(d => selectedDemandes.includes(d.id));
    const emails = selected.map(d => d.demandeur?.email).filter(Boolean);
    
    alert(`Notifier les demandeurs : ${emails.join(', ')}`);
  };

  if (loading && demandes.length === 0) {
    return (
      <div className="min-h-screen  p-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Chargement des demandes prêtes...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen  p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                Demandes prêtes à récupérer
              </h1>
              <p className="text-gray-600">
                Gestion des demandes préparées et prêtes pour récupération
              </p>
            </div>
            
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/magasin/validated-demandes')}
                className="px-4 py-2 border border-gray-300 text-gray-700 hover: rounded-lg font-medium flex items-center gap-2"
              >
                <ArrowRight className="w-4 h-4 rotate-180" />
                Retour aux demandes
              </button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="text-sm text-gray-500">Prêtes à récupérer</div>
              <div className="text-2xl font-bold text-blue-600">{demandes.length}</div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="text-sm text-gray-500">Sélectionnées</div>
              <div className="text-2xl font-bold text-orange-600">{selectedDemandes.length}</div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="text-sm text-gray-500">Attente moyenne</div>
              <div className="text-2xl font-bold text-gray-900">2h30</div>
            </div>
          </div>

          {/* Actions batch */}
          {selectedDemandes.length > 0 && (
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <CheckSquare className="w-5 h-5 text-blue-600" />
                  <div>
                    <p className="font-medium text-blue-800">
                      {selectedDemandes.length} demande(s) sélectionnée(s)
                    </p>
                    <p className="text-sm text-blue-600">
                      Actions groupées disponibles
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <button
                    onClick={handleNotify}
                    className="px-4 py-2 bg-white border border-blue-300 text-blue-700 hover:bg-blue-50 rounded-lg font-medium flex items-center gap-2"
                  >
                    <Bell className="w-4 h-4" />
                    Notifier
                  </button>
                  <button
                    onClick={handleMarkAsRecovered}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium flex items-center gap-2"
                  >
                    <CheckCircle className="w-4 h-4" />
                    Marquer récupérée
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Filtres et recherche */}
          <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                    placeholder="Rechercher une demande..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
              
              <div className="flex gap-3">
                <button
                  onClick={selectAll}
                  className="px-4 py-2 border border-gray-300 text-gray-700 hover: rounded-lg font-medium flex items-center gap-2"
                >
                  <CheckSquare className="w-4 h-4" />
                  {selectedDemandes.length === filteredDemandes.length ? 'Tout désélectionner' : 'Tout sélectionner'}
                </button>
                
                <button
                  onClick={() => alert('Export PDF - Fonctionnalité à implémenter')}
                  className="px-4 py-2 border border-gray-300 text-gray-700 hover: rounded-lg font-medium flex items-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  Exporter
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Liste des demandes */}
        {filteredDemandes.length === 0 ? (
          <div className="bg-white rounded-xl border border-gray-200 p-12 text-center">
            <Truck className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Aucune demande prête
            </h3>
            <p className="text-gray-600">
              {searchTerm 
                ? 'Aucune demande ne correspond à votre recherche.'
                : 'Toutes les demandes ont été récupérées ou sont en préparation.'}
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {filteredDemandes.map((demande) => {
              const isSelected = selectedDemandes.includes(demande.id);
              const waitingTime = Math.floor((new Date() - new Date(demande.date_preparation)) / (1000 * 60 * 60));
              
              return (
                <div 
                  key={demande.id}
                  className={`bg-white rounded-xl border-2 overflow-hidden transition-all duration-200 ${
                    isSelected 
                      ? 'border-blue-500 bg-blue-50/30' 
                      : 'border-gray-200 hover:border-blue-300 hover:shadow-md'
                  }`}
                >
                  <div className="p-6">
                    <div className="flex items-start gap-4">
                      {/* Checkbox */}
                      <div className="pt-1">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => toggleSelectDemande(demande.id)}
                          className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                      </div>
                      
                      {/* Informations */}
                      <div className="flex-1">
                        <div className="flex flex-wrap items-start justify-between gap-2 mb-4">
                          <div>
                            <h3 className="font-semibold text-gray-900 text-lg mb-1">
                              Demande #{demande.numero || demande.id}
                            </h3>
                            <div className="flex flex-wrap items-center gap-3 text-sm text-gray-500">
                              <span className="flex items-center gap-1">
                                <User className="w-3 h-3" />
                                {demande.demandeur?.nom || 'N/A'}
                                {demande.demandeur?.email && ` (${demande.demandeur.email})`}
                              </span>
                              <span>•</span>
                              <span className="flex items-center gap-1">
                                <Calendar className="w-3 h-3" />
                                Prête depuis {new Date(demande.date_preparation).toLocaleDateString('fr-FR')}
                              </span>
                              <span>•</span>
                              <span className="flex items-center gap-1">
                                <Clock className="w-3 h-3" />
                                {waitingTime > 0 ? `Attente: ${waitingTime}h` : 'Prête aujourd\'hui'}
                              </span>
                            </div>
                          </div>
                          
                          <span className="px-3 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800 border border-blue-200">
                            Prête à récupérer
                          </span>
                        </div>
                        
                        {/* Matériels préparés */}
                        <div className="mb-4">
                          <h4 className="text-sm font-medium text-gray-700 mb-2">Matériels préparés</h4>
                          <div className="flex flex-wrap gap-2">
                            {demande.demande_materiels
                              ?.filter(dm => dm.statut === 'prete')
                              .slice(0, 5)
                              .map(dm => (
                                <span 
                                  key={dm.materiel_id}
                                  className="px-3 py-1 bg-green-50 text-green-700 border border-green-200 rounded-full text-xs"
                                >
                                  {dm.materiel?.nom} ({dm.quantite_preparee})
                                </span>
                              ))}
                            
                            {demande.demande_materiels?.filter(dm => dm.statut === 'prete').length > 5 && (
                              <span className="px-3 py-1  text-gray-600 border border-gray-200 rounded-full text-xs">
                                +{demande.demande_materiels.filter(dm => dm.statut === 'prete').length - 5} autres
                              </span>
                            )}
                          </div>
                        </div>
                        
                        {/* Emplacement / Point de retrait */}
                        <div className="p-3  border border-gray-200 rounded-lg">
                          <div className="text-sm">
                            <span className="font-medium text-gray-700">Point de retrait:</span>
                            <span className="text-gray-600 ml-2">Magasin principal - Zone de récupération</span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Actions */}
                      <div className="flex flex-col gap-2">
                        <button
                          onClick={() => navigate(`/magasin/demandes/${demande.id}/details`)}
                          className="px-4 py-2 border border-gray-300 text-gray-700 hover: rounded-lg font-medium text-sm"
                        >
                          Voir fiche
                        </button>
                        <button
                          onClick={() => alert(`Contacter ${demande.demandeur?.nom}`)}
                          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium text-sm"
                        >
                          Contacter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Instructions */}
        <div className="mt-8 bg-white rounded-xl border border-gray-200 p-6">
          <h3 className="font-medium text-gray-900 mb-3">Instructions pour la récupération</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-start gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
              <span>Vérifier l'identité du demandeur avant de remettre les matériels</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
              <span>Scanner les QR codes des matériels lors de la remise</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
              <span>Faire signer le bon de livraison / récupération</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
              <span>Marquer la demande comme "récupérée" après remise effective</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}